import React from "react"
import { User } from "firebase/auth"
import { useForm } from "react-hook-form"
import { LiveId, SpaceKey } from "popopo-msg"
import { api } from "../../core"

export const SpaceLiveStopForm = (props: {
  firebase: User;
  spaceKey: SpaceKey;
  liveId: LiveId;
}) => {
  const form = useForm({
    mode: "onBlur",
  })

  const onLiveDelete = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.DELETE("/api/v2/spaces/{space_key}/lives/{live_id}", {
        params: { path: { space_key: props.spaceKey, live_id: props.liveId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100">
        <button type="button" className="btn btn-danger form-control" onClick={form.handleSubmit(onLiveDelete)}>
          Stop Live
        </button>
      </form>
    </>
  )
}
